






















































// @ts-nocheck
import Vue from 'vue';
// import RecordLegend from './components/record/Legend.vue';
import RecordItem from './components/record/Item.vue';
import { RecordStore } from '@/store/index';
import { throttle } from '@/business/helper';
import charity from '@/business/charity';
// import { elk } from '@tencent/ppd-base-libs';
import { FitIcon, FitButton } from '@/fit-ui';
import { biHottag } from '@tencent/ppd-base-libs';

export default Vue.extend({
  name: 'record',
  data() {
    return {
      RecordStore,
      inPage: false,
      recordScrollTop: 0, // 记录滚动位置
    };
  },
  async created() {
    charity.hisQry();
    this.onScrollF = throttle(this.onScroll, 1000, true);
    document.addEventListener('scroll', this.onScrollF, false);
  },
  mounted() {
    this.inPage = true;

    this.setScrollTop(this.recordScrollTop);
  },
  activated() {
    biHottag('wallet.charity.histroy.index_view');
  },
  methods: {
    eGoDtl(item) {
      // let _test =  {
      //     listid: item.listid,
      //     pid: item.product_id,
      //     oid: item.organization_id
      // };
      // alert(JSON.stringify(_test));
      sessionStorage.setItem('from_record_item', JSON.stringify(item));
      this.$router.push({
        path: '/result',
      });
    },
    async onScroll() {
      if (this.checkIsBottom(20) && this.inPage) {
        charity.hisQry();
      }
    },
    checkIsBottom(gap) {
      let height: any;
      if (this.$refs.record) {
        height = this.$refs.record.offsetHeight;
      }
      if (!height && document.getElementById('scroll')) {
        height = document.getElementById('scroll').offsetHeight;
      }

      const scrollTop = this.getScrollTop();
      return scrollTop + window.screen.height + gap > height;
    },
    /**
       * 获取页面滚动距离
       */
    getScrollTop() {
      let scrollTop = window.pageYOffset || 0;

      if (document.scrollingElement) {
        // @ts-ignore
        ({ scrollTop } = document.scrollingElement);
      } else if (document.body.scrollTop) {
        ({ scrollTop } = document.body);
      }

      return scrollTop;
    },
    setScrollTop(top) {
      if (document.scrollingElement) {
        document.scrollingElement.scrollTop = top;
      } else {
        document.body.scrollTop = top;
      }
    },
    returnHome() {
      biHottag('wallet.charity.histroy.go_donate_click');
      setTimeout(() => {
        location.href = '/charity/index.shtml';
      }, 100);
    },
  },
  components: {
    // RecordLegend,
    RecordItem,
    FitIcon,
    FitButton,
  },
});
